"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
var component_loading_1 = __importDefault(require("@doordash/component-loading"));
var React = __importStar(require("react"));
var App_1 = require("../App");
var LayoutContext_1 = require("../Common/LayoutContext");
var enums_1 = require("../Common/utils/enums");
var MfaAutoSendFailed_1 = __importDefault(require("./components/MfaAutoSendFailed"));
var MfaBlocked_1 = __importDefault(require("./components/MfaBlocked"));
// tslint:disable-next-line:max-line-length
var useGeneratePasscodeMutation_1 = __importDefault(require("./Providers/useGeneratePasscodeMutation"));
var ImpressionTracker_1 = __importDefault(require("./Tracking/ImpressionTracker"));
var TwoFactorAuthenticationStrings_1 = __importDefault(require("./TwoFactorAuthenticationStrings"));
var TwoFactorAuthenticationUtils_1 = require("./TwoFactorAuthenticationUtils");
var VerifyAccountContext_1 = __importDefault(require("./VerifyAccountContext"));
var VerifyAccountStyles_1 = require("./VerifyAccountStyles");
var VerifyAccountTracking_1 = require("./VerifyAccountTracking");
var VerifyPasscode_1 = __importDefault(require("./VerifyPasscode"));
var VerifyAccountController = function (_a) {
    var additionalMfaOptions = _a.additionalMfaOptions, initialChannel = _a.initialChannel;
    var _b = React.useContext(App_1.RiskContext), client = _b.client, state = _b.state, shouldUseRiskBff = _b.shouldUseRiskBff;
    var _c = React.useContext(LayoutContext_1.LayoutContext), clearActionState = _c.clearActionState, setPrimaryAction = _c.setPrimaryAction, setSecondaryAction = _c.setSecondaryAction;
    var _d = React.useContext(VerifyAccountContext_1["default"]), blockChannelSwitch = _d.blockChannelSwitch, channel = _d.channel, mfaState = _d.mfaState, setMfaState = _d.setMfaState;
    var _e = useGeneratePasscodeMutation_1["default"](), sendCode = _e.sendCode, sendData = _e.sendData, sendError = _e.sendError;
    var isRestClient = !(client || shouldUseRiskBff);
    // Auto send code on challenge trigger.
    React.useEffect(function () {
        sendCode(channel);
    }, []);
    // Handle auto send failure and success.
    React.useEffect(function () {
        if (sendError) {
            if (TwoFactorAuthenticationUtils_1.isUserBlocked(isRestClient, sendError)) {
                setMfaState(enums_1.MfaStates.Blocked);
            }
            else {
                setPrimaryAction(__assign(__assign({}, clearActionState), { text: initialChannel === enums_1.TwoFactorChannels.Email
                        ? TwoFactorAuthenticationStrings_1["default"].sendToEmail()
                        : TwoFactorAuthenticationStrings_1["default"].sendToMobile() }));
                if (!blockChannelSwitch && setSecondaryAction) {
                    setSecondaryAction(__assign(__assign({}, clearActionState), { text: TwoFactorAuthenticationStrings_1["default"].sendToEmail() }));
                }
                setMfaState(enums_1.MfaStates.AutoSendFailed);
            }
        }
    }, [sendError]);
    // Handle auto send success.
    React.useEffect(function () {
        if (sendData) {
            setPrimaryAction({
                isDisabled: true,
                isSubmitting: false,
                text: TwoFactorAuthenticationStrings_1["default"].submit()
            });
            // Verification state doesn't need a secondary action.
            if (setSecondaryAction) {
                setSecondaryAction(clearActionState);
            }
            setMfaState(enums_1.MfaStates.Verification);
        }
    }, [sendData]);
    var contentToShow = React.useMemo(function () {
        switch (mfaState) {
            case enums_1.MfaStates.AutoSendFailed:
                return (React.createElement(MfaAutoSendFailed_1["default"], { sendCode: sendCode, initialChannel: initialChannel }));
            case enums_1.MfaStates.Blocked:
                return React.createElement(MfaBlocked_1["default"], { additionalMfaOptions: additionalMfaOptions });
            case enums_1.MfaStates.Loading:
                return (React.createElement(VerifyAccountStyles_1.LoadingWrapper, null,
                    React.createElement(component_loading_1["default"], { size: component_loading_1["default"].Sizes.Large })));
            case enums_1.MfaStates.Verification:
                return (React.createElement(ImpressionTracker_1["default"], { onImpression: function () { return VerifyAccountTracking_1.trackChallengeTrigger(state.workflow); } },
                    React.createElement(VerifyPasscode_1["default"], { additionalMfaOptions: additionalMfaOptions, loadData: sendData, primaryText: TwoFactorAuthenticationStrings_1["default"].forSecurityIsYou() })));
            default:
                return null;
        }
    }, [mfaState, sendData]);
    return (React.createElement(VerifyAccountStyles_1.Root, null,
        React.createElement(VerifyAccountStyles_1.MfaContainer, null, contentToShow)));
};
exports["default"] = VerifyAccountController;
